import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";

import ChallengeOverview from "@/components/ChallengeOverview/ChallengeOverview";

const Component = () => {
  const search = Route.useSearch();
  return <ChallengeOverview initialTab={search.tab} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/")({
  component: Component,
  validateSearch: (search: { tab?: string } & SearchSchemaInput) => {
    console.log("validate", search.tab);
    if (search.tab && !["profile", "routes", "entries"].includes(search.tab as string)) {
      return { tab: "entries" } as const;
    }
    return {
      tab: search.tab as "profile" | "entries" | undefined,
    };
  },
});
